// services/apiClient.js
import axios from 'axios'
import { resolveApiUrl } from './resolveApiUrl.js'
import { env } from '../config/env';

const apiClient = axios.create({
    baseURL: `${resolveApiUrl()}/api`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Log de debug pour vérifier l'URL utilisée
if (env.DEBUG_MODE) {
    console.log('🔧 API Client Configuration:', {
        baseURL: env.API_BASE_URL,
        timeout: env.API_TIMEOUT,
        environment: env.APP_ENV
    })
}

// Intercepteur pour le token
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Intercepteur pour les erreurs 401
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('user')
            window.location.href = '/'
        }
        return Promise.reject(error)
    }
)

export default apiClient